export default () => ({
  contracts: null,
  contract: null,
  links: null,
  meta: null,
  hasData: false,
  error: null,
});
